// extracted by mini-css-extract-plugin
export default {"wrapper":"MainInfo_wrapper__ApQVH"};